export enum RepaymentSchedule {
  Daily = 0,
  Weekly,
  Monthly,
  Annually,
  Fortnightly,
  Biannually,
}
